<template>
  <van-popup
    v-model="showMenu"
    position="left"
    :style="{ height: '100vh', width: '65%' }"
    :close-on-popstate="true"
  >
    <div>
      <div class="account-box" v-if="shopData">
        <div
          class="account-avatar"
          @click="$router.push({ name: 'mine' }, () => {})"
        >
          <img v-if="shopData.logo" :src="shopData.logo" />
          <img v-else src="../../../assets/avatar.png" />
        </div>
        <div class="btns">
          <div>
            <van-button
              size="small"
              style="width: 80%"
              icon="edit"
              @click="$router.push({ name: 'editusr' }, () => {})"
              >编辑</van-button
            >
          </div>
          <div class="btn">
            <van-button
              size="small"
              style="width: 80%"
              icon="share-o"
              @click="toLogout"
              >退出</van-button
            >
          </div>
        </div>
      </div>
      <div class="shop-info" v-if="shopData">
        <ul>
          <li>官方验证： {{ shopData.name }}</li>
          <li>用户名： {{ shopData.username }}</li>
          <li>
            商店评分：
            <van-icon
              name="star"
              class="star"
              v-for="item in shopData.star"
              :key="item"
            />
          </li>
          <li><span class="title">信用积分</span>： {{ shopData.credit }}</li>
          <li>
            <span class="title">日访问量</span>： {{ shopData.daily_visits }}
          </li>
          <li>
            <span class="title">店铺收藏</span>：
            {{ shopData.collection_quantity }}
          </li>
          <li>
            <span class="title">店铺好评</span>： {{ shopData.positive_review }}
          </li>
        </ul>
      </div>
      <div
        class="shop-info1"
        v-if="!shopData && checkCode==221"
        style="text-align: center"
        @click="$router.push({ name: 'certification' }, () => {})"
      >
        认证身份
      </div>
      <div
        class="shop-info1"
        v-if="!shopData  && checkCode==222"
        style="text-align: center"
        @click="OpenSeller()"
      >
        开设店铺
      </div>
      <div class="menu-list">
        <van-cell-group>
          <van-cell
            icon="wap-home-o
"
            title="首页"
            is-link
            to="/"
          />
          <van-cell
            v-if="shopData"
            icon="shop-o
"
            title="店铺首页"
            is-link
            :to="'/shop?id=' + shopData.id"
          />
          <van-cell
            icon="setting-o
"
            title="店铺商品"
            v-if="checkCode == 200"
            is-link
            to="mine"
          />
          <van-cell icon="paid" title="我的钱包" is-link to="wallet" />
          <van-cell icon="bars" title="古董店铺设置" is-link to="seller" />
        </van-cell-group>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { removeToken } from '@/utils/cookies'
import { Dialog } from 'vant'
export default {
  name: 'MineMenuView',
  data () {
    return {
      showMenu: false,
      shopData: null,
      checkCode: null
    }
  },
  watch: {
    showMenu (val) {
      if (val) {
        this.checkUsr()
      }
    }
  },
  methods: {
    async OpenSeller () {
      await this.$http({
        method: 'post',
        url: 'openseller'
      }).then(res => {
        this.$toast.success(res.msg)
         setTimeout(() => {
                        location.reload()
                    }, 2000);
      })
    },
    async checkUsr () {
      await this.$http({
        method: 'post',
        url: 'check'
      }).then(res => {
        this.checkCode = res.data.check_code
        this.getshop()
      })
    },
    async getshop () {
      await this.$http({
        method: 'post',
        url: 'getShopInfo'
      }).then(res => {
        if (res && res.data) this.shopData = res.data.shop_info
      })
    },
    async getUsr () {
      await this.$http({
        method: 'post',
        url: 'getusr'
      }).then(res => {
        console.log(res)
      })
    },
    toLogout () {
      Dialog.confirm({
        title: '提示',
        message: '是否退出当前账号？'
      })
        .then(() => {
          removeToken()
          this.$router.push({ name: 'home' }, () => {})
        })
        .catch(() => {})
    }
  }
}
</script>
<style lang="scss" scoped>
.account-box {
  width: 100%;
  display: flex;
  gap: 10px;
  padding-top: 20px;
  .account-avatar {
    flex: 2;
    img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin-left: 60px;
    }
  }
  .btns {
    flex: 1;
    position: relative;
    .btn {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
    }
  }
}
.shop-info {
  border-radius: 8px;
  border: 1px solid #dcded0;
  margin: 10px;
  padding: 10px;
  font-size: 14px;
  ul {
    padding: 0;
    list-style: none;
    li {
      margin: 10px 0;
      .star {
        color: #faab0c;
      }
      span.title {
        color: #faab0c;
        font-weight: 550;
      }
    }
  }
}
.shop-info1 {
  border-radius: 8px;
  color: #a54b4e;
  background: #f3c7c6;
  border: 1px solid #a54b4e;
  margin: 10px;
  padding: 10px;
  font-size: 14px;
}
</style>
